import script from "./SiteNav.vue?vue&type=script&lang=ts&setup=true"
export * from "./SiteNav.vue?vue&type=script&lang=ts&setup=true"

import "./SiteNav.vue?vue&type=style&index=0&id=7889549c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7889549c"]])

export default __exports__